const SOURCE_MAP = {
  CHE_WU_HOU_TAI: 1,
  SHANG_CHENG: 2,
}
const CONTRACT_STATE_MAP_NEW = {
  DAIFAQI: 0,
  QIANSHUZHONG: 1,
  QIANYUECHENGGONG: 2,
  YICHEXIAO: 3,
  YIGUOQI: 5,
  JUQIAN: 7,
  QIANYUESHIBAI: 8,
}

const CONTRACT_STATE_MAP = {
  DAIFAQI: 0,
  QIANSHUZHONG: 1,
  QIANYUECHENGGONG: 2,
  QIANYUESHIBAI: 3,
  YICHEHUI: 5,
  YIZUOFEI: 6,
  CHEHUIHZONG: 7,
  SHENPIZHONG: 8,
}

const CONTRACT_TYPE_MAP = {
  LEASE: 1,
  WITHHOLD: 2,
  PACKAGE: 3,
  FRAMEWORK: 4,
  PERSON_WITHHOLD: 5,
}

export default {
  newLastPeriodRuleList: {
    0: '月租金减首期租金',
    1: '日租金乘以尾期天数',
  },
  delayPayFlagList: {
    0: '当期',
    1: '下期',
    2: '订单收款起始日',
    10: '自定义',
  },
  orderState: {
    1: '已创建',
    2: '进行中',
    3: '已关闭',
  },
  // 租赁中 企业主订单订单状态
  underLeaseOrderStateList: {
    1: '已创建',
    2: '进行中',
    3: '已关闭',
  },
  // 是否续约
  renewalOfContractList: {
    0: '否',
    1: '是',
  },
  schemeTypeList: {
    0: '固定方案',
    1: '阶梯方案',
  },
  lastPeriodRuleList: {
    0: '月租金减首期租金',
    1: '尾期租金以日租金乘以尾期天数计算',
  },
  // 订单类型
  relationOrderTypeList: {
    10: '个人租赁订单',
    20: '企业租赁订单',
  },
  // 方案类型
  leaseOrderTypeList: {
    1: '个人租赁方案',
    2: '企业租赁方案',
  },
  // 缴款状态
  paymentStateList: {
    0: '未缴款',
    1: '已缴款',
  },
  // 订单类型
  relatedOrderTypeList: {
    1: '个人',
    2: '企业',
  },
  // 租赁信息类别
  categoryList: {
    1: '租车',
    2: '以租代购',
    3: '司机合作模式',
  },
  // 处置方式
  disposalMethodList: {
    1: '退回车源方',
    2: '个人购买',
    3: '公司回购',
    4: '保险赔付',
    5: '其他',
  },
  // 车辆状态
  carStatus: {
    0: '全部',
    1: '待入库',
    2: '待上证',
    3: '待租',
    4: '已租',
    5: '车辆异常',
  },
  // 验车单
  hasInspectionList: {
    0: '未上传',
    1: '已上传',
  },
  // 准驾车型
  driverLicenceCarModel: {
    0: 'C1',
    1: 'B1',
    2: 'B2',
    3: 'A1',
    4: 'A2',
    5: 'A3',
  },
  // 线上代扣协议确认状态
  confirmStateList: {
    0: '未确认',
    1: '已确认',
  },
  payMethods: {
    10: '线下支付',
    20: '网约钱包支付',
    40: '商城支付',
    50: '支付宝支付',
  },
  outInState: {
    0: '待处理',
    1: '已完成',
    2: '已作废',
  },
  // 审核状态
  carExamineState: {
    0: '待审核',
    1: '驳回',
    2: '通过',
  },
  // 车辆审核类型
  carExamineTypeDict: {
    1: '车辆基本信息审核',
    2: '维保记录审核',
    3: '事故记录审核',
    4: '保单记录审核',
    5: '违章记录审核',
  },
  // 待租标准类型
  carRentStandardTypeList: {
    1: '车辆基本信息完整',
    2: '年审无临过期',
    3: '车证无临过期',
    4: '车辆运营状态正常',
    5: '车险无临过期',
    6: '违章处理完成',
  },
  // 待租标准
  carRentStandardType: {
    1: '车辆基本信息完整',
    2: '待租标准中，车辆信息及证照状态相关信息模块开启的校验',
    3: '',
    4: '车辆运营状态正常',
    5: '车险无临过期',
    6: '违章处理完成',
  },
  // 待租标准判断规则
  carRentStandardRules: {
    1: '已选择车型',
    2: '已填写VIN车架号',
    3: '已填写车牌号',
    4: '已填写发动机号',
    5: '已上传行驶证照片(主)',
    6: '已上传行驶证照片(副)',
    7: '已填写行驶证注册日期',
    8: '已填写行驶证年检有效期',
    9: '已上传登记证照片',
    10: '已上传网约车证照片',
    11: '已填写网约车证有效期',
    12: '有效期大于15天',
    13: '有效期大于15天',
    14: '维保事故处理完毕',
    15: '交强险状态为生效中且有效期大于30天',
    16: '商业险状态为生效中且有效期大于30天',
    17: '无待处理罚分情况',
  },
  // 发起条件
  carExamineInitiatingConditions: {
    1: '编辑提交车辆基本信息',
    2: '提交已完成的维保单',
    3: '提交已完成的事故单',
    4: '新建或编辑保单信息',
    5: '提交已处理违章记录',
  },
  // 资源状态
  resourcesState: {
    0: '无效',
    1: '有效',
  },
  // 资源类型
  resourcesType: {
    3: '主菜单',
    2: '按钮',
    1: '页面',
    4: '功能模块',
  },
  // 收款单状态
  collectionStateList: {
    0: '付款中',
    1: '已完成',
    2: '已作废',
  },
  moneyStateList: {
    0: '收款中',
    1: '已完成',
    2: '已作废',
  },
  // 付款方类型
  payerList: {
    1: '服务商',
    2: '客户',
    10: '其他',
  },
  // 订单类型
  orderTypeList: {
    1: '企业租赁',
    2: '采购',
  },
  // 订单状态
  orderStateList: {
    1: '待确认',
    2: '进行中',
    3: '已完成',
    4: '已关闭',
  },
  vehiclePurchaseStatus: {
    0: '未采购',
    1: '采购待确认',
    2: '采购中',
    3: '已采购',
  },
  // 客户来源
  customerSourceList: {
    1: '招募',
    2: '推荐',
    3: '商城',
  },
  SOURCE_MAP,
  CONTRACT_STATE_MAP_NEW,
  // 下单方式
  source: {
    [SOURCE_MAP.CHE_WU_HOU_TAI]: '车务后台',
    [SOURCE_MAP.SHANG_CHENG]: '商城',
  },
  // 关联原因
  relationReasonList: {
    1: '合同临时换车',
    2: '合同换车',
    3: '合同换人',
    4: '合同续约',
  },
  // 是否
  isWhetherList: {
    0: '否',
    1: '是',
  },
  isHaveList: {
    1: '有',
    2: '无',
  },
  // 税票类型
  taxTypeList: {
    0: '普通发票',
    1: '增值税专用票',
    2: '专用发票',
  },
  // 合同状态
  contractStateList: [
    {
      value: 1,
      label: '待签约',
    },
    {
      value: 2,
      label: '已签约',
    },
    {
      value: 3,
      label: '已完成',
    },
    {
      value: 4,
      label: '已作废',
    },
    {
      value: 5,
      label: '已解约',
    },
  ],
  // 收款方类型
  payeeTypeDict: {
    1: '向服务商付款',
    2: '向客户付款',
    10: '其他付款',
  },
  // 用户状态
  accountStateDict: {
    0: '禁用',
    1: '启用',
  },
  accountStateList: [
    {
      value: 0,
      label: '禁用',
    },
    {
      value: 1,
      label: '启用',
    },
  ],
  // 账户类型
  accountTypeDict: {
    1: '收款账户',
    2: '付款账户',
  },
  // 完成状态
  completionStatusDict: {
    0: '未完成',
    1: '已完成',
    2: '已关闭',
  },
  // 付款状态
  paymentStatusDict: {
    0: '未完成',
    1: '已完成',
    2: '已关闭',
    3: '待订单核算',
  },
  catStateDict: {
    0: '启用',
    1: '禁用',
  },
  completionStatusList: [
    {
      value: 0,
      label: '未完成',
    },
    {
      value: 1,
      label: '已完成',
    },
  ],

  // 来源单类型
  sourceOrderTypeDict: {
    2: '个人租赁订单',
    3: '维保单',
    4: '事故单',
    5: '采购订单',
    6: '企业租赁订单',
    7: '商城采购单',
    // 100: '其他'
  },
  sourceOrderTypeList: [
    {
      value: 1,
      label: '出入库记录',
    },
    {
      value: 2,
      label: '车辆租赁合同',
    },
    {
      value: 3,
      label: '维保单',
    },
    {
      value: 4,
      label: '事故单',
    },
    {
      value: 100,
      label: '其他',
    },
  ],

  // 合同签约状态
  contractSignStateDict: {
    1: '待签约',
    2: '已签约',
    3: '已完成',
    4: '已作废',
    5: '已解约',
  },

  // 汽车签约状态
  carSignStateDict: {
    1: '未签约',
    2: '签署中',
    3: '已签约',
  },

  // 收付款状态
  batchStateDict: {
    10: '待处理',
    0: '进行中',
    1: '已完成',
    2: '已作废',
  },
  // 收付款方类型
  customerTypeDict: {
    1: '服务商',
    2: '客户',
    10: '其他',
  },
  // 变更计划
  accruedTypeDict: {
    1: '应收变更',
    2: '应付变更',
  },

  // 汽车运营状态
  carOperateStateDict: {
    1: '正常',
    2: '保养中',
    3: '维修中',
    4: '事故中',
  },

  // 汽车运营状态对应颜色
  carOperateStateColorDict: {
    1: '#2E7EFF',
    2: '#F5770A',
    3: '#F5770A',
    4: '#F5770A',
  },

  // 采购类型
  purchaseType: {
    1: '购买',
    2: '租用',
  },

  // 采购方式
  carPurchaseType: {
    1: '购买',
    2: '租用',
  },

  // 合同业务类型
  contractBusinessTypeDict: {
    1: '租赁合同',
  },

  // 操作系统类型
  operateSystemTypeDict: {
    1: '车务PC后台',
    2: '车务小程序',
  },

  // 服务商类型
  serviceProviderTypeDict: {
    0: '车源方',
    1: '维修厂',
    2: '保险公司',
    3: '产权方',
  },

  // 维保类型
  maintenanceTypeDict: {
    1: '维修',
    2: '保养',
    // 3: '维保',
    4: '事故',
  },

  // 维保状态
  // maintenanceStateDict: {
  //   1: '待处理',
  //   2: '处理中',
  //   3: '已完成'
  // },

  // 维保状态
  maintenanceStateDict: {
    1: '待维保',
    2: '维保中',
    3: '已完成',
    5: '待司机付款',
  },

  // 来源类型
  maintenanceSourceDict: {
    1: '维修厂',
    0: '录入',
  },

  // 事故状态
  accidentStatusDict: {
    1: '待处理',
    2: '处理中',
    3: '已完成',
    5: '作废',
  },

  // 结算状态
  settlementStatusDict: {
    1: '未结算',
    2: '已结算',
  },

  // 出险状态
  outInsuranceStatusDict: {
    1: '待定损',
    2: '已定损待结案',
    3: '已结案待理赔',
    4: '理赔完成',
    5: '销案',
  },

  // 保险类型
  insuranceTypeDict: {
    1: '交强险',
    2: '商业险',
    3: '承运人责任险',
    4: '客伤险',
    5: '车船税',
    6: '盗抢险',
  },

  // 事故类型
  accidentTypeDict: {
    1: '单方',
    2: '多方',
    3: '双方',
  },

  // 事故责任
  accidentResponsibilityDict: {
    1: '主要责任',
    2: '次要责任',
    3: '无责',
    4: '全责',
    5: '同责',
  },

  // 支付形式
  paymentformDict: {
    1: '一次性支付',
    2: '分期付款',
    3: '周付',
  },

  // 支付内容
  paymentcontentDict: {
    1: '租金',
    2: '押金',
    3: '管理费',
    4: '服务费',
  },

  // 计划状态
  planstatusDict: {
    0: '未生成',
    1: '已生成',
    2: '关闭',
  },

  // 合同类型
  typeofcontractDict: {
    1: '租赁',
    2: '采购',
    3: '处置',
    4: '抵押',
  },

  // 客户类型
  customertypeDict: {
    1: '个人',
    2: '企业',
  },

  // 支付计划类型
  paymenttypeDict: {
    1: '按月预付',
    2: '按月后付',
    3: '按周支付',
  },
  generatiaoDict: {
    1: '星期一',
    2: '星期二',
    3: '星期三',
    4: '星期四',
    5: '星期五',
    6: '星期六',
    7: '星期日',
  },
  // 处理状态
  processingstatusDict: {
    0: '未处理',
    1: '已处理',
    3: '未处理已人车分离',
  },
  purchaseTypeDict: {
    1: '购买',
    2: '租用',
  },
  purchaseStateDict: {
    1: '待确认',
    2: '进行中',
    3: '已完成',
    4: '已关闭',
  },
  closeTypeDict: {
    1: '提前解约',
    2: '合同到期',
  },
  importStatus: {
    1: '导入中',
    2: '处理中',
    3: '全部成功',
    4: '全部错误',
    5: '部分错误',
  },
  importPayStatus: {
    1: '处理中',
    2: '处理中',
    3: '处理成功',
    4: '处理失败',
    5: '处理失败',
  },
  ocrStatus: {
    1: '导入中',
    2: '处理中',
    3: '全部成功',
    4: '全部错误',
    5: '部分错误',
    6: '暂不支持',
    7: '未选择执行',
  },
  taskType: {
    10: '身份证人像面',
    11: '驾驶证正页',
    12: '网约车驾驶员证',
    20: '营业执照',
    30: '行驶证主页',
    33: '行驶证副页',
    31: '登记证照片',
    32: '网约车证照片',
    13: '身份证国徽面',
    14: '驾驶证副页',
    51: '保单信息',
    52: '停复保信息',
    53: '交强险',
    54: '商业险',
    55: '承运人责任险',
    56: '客伤险',
    57: '车船税',
    58: '盗抢险',
    61: '创建车辆信息',
    62: '确认到库车辆信息',
    63: '事故信息',
    64: '批量线下收款',
    65: '批量线下付款',
    66: '销售线索',
  },
  orderCarStatus: {
    0: '正常',
    1: '退车',
    2: '追加',
  },
  vehicleStatus: {
    // 车辆状态
    10: '待处理',
    20: '待租',
    30: '备车',
    40: '已租',
  },
  // 租赁方案状态
  leasingSchemeState: {
    0: '未上架',
    1: '已上架',
  },
  // 租赁方案分期
  leasingSchemeByStages: {
    3: '3个月',
    6: '6个月',
    12: '12个月',
  },
  // 车辆审核状态
  carExamineStateDict: {
    0: '待审核',
    1: '驳回',
    2: '通过',
  },
  // 结算状态
  settlementForm: {
    0: '待核算',
    1: '核算完成',
    2: '审批中',
    3: '结算中',
    4: '核算失败',
  },
  // 个人租凭订单状态
  stateSeven: {
    0: '待确认',
    1: '待出库',
    2: '履约中',
    3: '待入库',
    4: '核算中',
    5: '已关闭',
  },
  // 合同签署状态
  contractSeven: {
    1: '待签约',
    2: '签约成功',
    3: '签约失败',
    4: '已撤销',
    5: '已解约',
  },
  // 签署方式
  signingType: {
    0: '线下签署',
    1: '线上签署',
  },
  togetherFlagType: {
    0: '否',
    1: '是',
  },
  // 签约渠道
  signingChannel: {
    1: '线下签约',
    2: 'e签宝',
  },
  // 七期支付形式
  payFormMessage: {
    2: '分期付租金',
    1: '一次性付租金',
    3: '司机合作模式',
  },
  payTypeMessage: {
    0: '按月预付',
  },
  // 发车前收款
  advancePayment: {
    0: '发车前不收',
    1: '收取首期',
    2: '收取全部',
  },
  // 日租金规则
  dailyRentRules: {
    0: '当月自然天数计算',
    1: '每月30天计算',
  },
  CONTRACT_STATE_MAP,
  // 租赁订单合同签约签约状态
  leaseOrderContractState: {
    [CONTRACT_STATE_MAP.DAIFAQI]: '待发起',
    [CONTRACT_STATE_MAP.QIANSHUZHONG]: '签署中',
    [CONTRACT_STATE_MAP.QIANYUECHENGGONG]: '签约成功',
    [CONTRACT_STATE_MAP.QIANYUESHIBAI]: '签约失败',
    [CONTRACT_STATE_MAP.YICHEHUI]: '已撤回',
    [CONTRACT_STATE_MAP.YIZUOFEI]: '已作废',
    [CONTRACT_STATE_MAP.CHEHUIHZONG]: '撤回中',
    [CONTRACT_STATE_MAP.SHENPIZHONG]: '审批中',
  },
  leaseOrderContractStateNew: {
    [CONTRACT_STATE_MAP_NEW.DAIFAQI]: '待发起',
    [CONTRACT_STATE_MAP_NEW.QIANSHUZHONG]: '签署中',
    [CONTRACT_STATE_MAP_NEW.QIANYUECHENGGONG]: '签约成功',
    [CONTRACT_STATE_MAP_NEW.YICHEXIAO]: '已撤销',
    [CONTRACT_STATE_MAP_NEW.YIGUOQI]: '已过期',
    [CONTRACT_STATE_MAP_NEW.JUQIAN]: '已拒签',
    [CONTRACT_STATE_MAP_NEW.QIANYUESHIBAI]: '签约失败',
  },
  // 订单关闭原因
  closingReason: {
    0: '订单作废',
    1: '发车失败',
    2: '提前解约',
    3: '到期解约',
  },
  // 订单关闭---退车类型(状态为：待确认、车辆待出库状态)
  returnTypeToBeConfirmed: {
    0: '订单作废',
    1: '发车失败',
  },
  // 订单关闭---退车类型(状态为：履约中状态)
  closingReasonInPerformance: {
    2: '提前解约',
    3: '到期解约',
  },
  // 订单关联原因
  rderRelatedReason: {
    1: '临时换车',
    2: '订单换车',
    3: '订单换人',
    4: '订单续约',
    5: '转租赁模式',
    10: '无关联订单', // 无关联订单原因-云效【PKXW-2708】
  },
  // 租赁订单状态
  leaseOrderState: {
    '-1500': '待绑车',
    0: '合同待签署',
    1000: '订单待支付',
    1500: '发车待验车',
    2500: '履约中',
    3500: '退车待验车',
    4500: '订单待核算',
    5000: '费用待结算',
    5500: '已关闭',
  },
  // 是否变更
  payeechange: {
    0: '否',
    1: '是',
  },
  // 开启车管移动端:
  openMoveClient: {
    10: '关闭',
    20: '开启',
  },
  plyers: {
    1: '公司',
    2: '司机',
    3: '保险公司',
    4: '厂家',
  },
  // 费用承担方
  costBearingParty: {
    // 0:'全部',
    1: '司机',
    2: '车务',
    3: '厂家',
    4: '保险公司',
    5: '车源方',
  },
  // 线上代扣类型
  withholdType: {
    1: '网约钱包支付',
    // 2: '支付宝支付'
  },
  // 线上支付渠道状态
  channelState: {
    0: '未开通',
    1: '已开通',
  },
  // 网约钱包支付客户签约状态
  walletWithholdState: {
    0: '待确认',
    1: '已签约',
    2: '已解约',
    10: '待司机确认',
    99: '待签约',
  },
  // 网约钱包支付客户签约状态
  walletWithhold2State: {
    0: '待确认',
    1: '已开启',
    2: '已解约',
    99: '未开启',
  },
  // 支付宝个人代扣状态
  alipayWithholdStateNew: {
    0: '待确认',
    1: '已签约',
    2: '已解约',
    10: '待扫码',
    99: '待签约',
  },
  // 支付宝支付客户签约状态
  alipayWithholdState: {
    0: '待签约',
    1: '已开启',
    2: '签约失败',
    99: '未开启',
  },
  // 退款方式
  refundMethod: {
    10: '原路返回',
  },
  // 扣款状态
  accruedState: {
    1: '进行中',
    2: '已完成',
    3: '已终止',
  },
  // 退款单状态
  refundState: {
    0: '退款中',
    1: '已完成',
    2: '已作废',
  },
  // 审批类型
  approvalType: {
    1: '后台审批',
    2: '钉钉审批',
  },
  // 审批状态
  approvalState: {
    10: '待审批',
    20: '已撤回',
    30: '已驳回',
    40: '已通过',
  },
  // 审批内容
  approvalBizType: {
    1: '收款审批',
    2: '个人租赁退车付款审批',
    3: '个人租赁退车收款审批',
    4: '支付宝支付解约',
    5: '网约钱包支付解约',
    6: '维保方案创建审批',
    7: '维保方案终止审批',
    8: '维保单创建审批',
    9: '维保方案套餐新增审批',
    10: '企业租赁订单换车审批',
  },
  // 采购订单状态枚举
  purchaseOrderState: {
    2: '进行中',
    4: '已关闭',
  },
  // 保单状态
  insuranceState: {
    1: '待生效',
    2: '已生效',
    3: '暂停中',
    4: '已过期',
  },
  // 审批来源
  approvalOrigin: {
    1: '应收列表线下收款',
    2: '应收列表批量线下收款',
    3: '个人订单详情线下收款',
    4: '个人订单详情批量线下收款',
    5: '企业租赁订单详情线下收款',
    6: '企业租赁订单详情批量线下收款',
    7: '催收预提醒线下收款',
    8: '催收逾期线下收款',
    9: '采购订单线下收款',
    10: '采购订单批量线下收款',
  },
  // 事故原因
  accidentReason: {
    1: '变道',
    2: '不按规定避让',
    3: '单方事故',
    4: '倒车',
    5: '追尾',
    6: '其他',
  },
  // 事故-是否人伤
  accidentPersonInjury: {
    0: '否',
    1: '是',
  },
  // 事故-结算状态
  accidentSettlementStatus: {
    0: '未完成',
    1: '已完成',
  },
  // 导出状态
  EXPORT_STATUS: {
    1: '进行中',
    3: '成功',
    4: '失败',
  },
  // 违章记录-处理方式
  dealViolationWayList: {
    1: '司机处理',
    2: '三方处理',
  },
  // 签约类型
  contractType: {
    [CONTRACT_TYPE_MAP.LEASE]: '租赁合同',
    [CONTRACT_TYPE_MAP.WITHHOLD]: '委托划扣协议（网约钱包支付）',
    [CONTRACT_TYPE_MAP.PERSON_WITHHOLD]: '委托划扣协议（支付宝支付）',
  },
  // 发起签署按钮
  signBtnText: {
    0: '发起线上签署',
    1: '撤回签署合同',
    2: '作废已签合同',
    3: '重新发起签署',
    5: '重新发起签署',
    6: '重新发起签署',
    7: '再次发起撤回',
  },

  signBtnTextNew: {
    0: '发起线上签署',
    1: '撤回签署合同',
    2: '解约委托划扣协议',
    3: '重新发起签署',
    5: '重新发起签署',
    7: '重新发起签署',
    8: '重新发起签署',
  },
}
